export default __webpack_public_path__ + "static/media/background.48419588.jpg";